// const isTouchDevice = "ontouchstart" in window || (window.navigator.maxTouchPoints > 0)
const isTouchDevice = "ontouchstart" in window

const clamp = (num, min, max) => Math.min(Math.max(num, min), max);

const lerp = (a,b,t) => a + (b-a) * t;

let scroll = {
	target: 0,
};

window.addEventListener("wheel", (e) => {
	e.preventDefault();
	scroll.target += e.deltaY;
	scroll.target = clamp(scroll.target, 0, document.scrollingElement.scrollHeight - window.innerHeight);
}, { passive: false });

var last = 0;

const update = (now) => {
	requestAnimationFrame(update)
	var dt = Math.min(1, (now - last) / 600);
	last = now;
	document.scrollingElement.scrollTop = lerp(document.scrollingElement.scrollTop, scroll.target, dt * 3);
}
// update()
// console.log(isTouchDevice)
if(!isTouchDevice){
	update()
}
else {
	document.querySelector('body').overflow='scroll !important';
}





